module.exports = __webpack_public_path__ + "img/TrialLogo.437ef7e1.png";